import React, { useEffect } from "react";
import {
  capitalizeFirstLetter,
  deleteFromStorage,
  saveToStorage,
} from "../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import { ResetPasswordAction } from "../../redux/Action/AuthAction";
import { ResubmitProfileAction } from "../../redux/Action/ProfileAction";
import { useNavigate } from "react-router-dom";
import { StorageConstants } from "../../constants/Constants";
import Button from "../Ui/Button";
import { Config } from "../../config/Config";
import { ImageContainer } from "../../constants/ImagesConstants";
import { FormattedMessage } from "react-intl";

const ApprovalPendingModel = ({ type, profile_data }: any) => {
  const dispatch = useDispatch<any>();
  const resubmit_data = useSelector((state: any) => state.ResubmitProfileState);
  const navigate = useNavigate();
  const handleButtonData = () => {
    deleteFromStorage({ key: "approval_status" });
    $(".btnClose").click();
  };

  const handleResubmit = () => {
    dispatch(ResubmitProfileAction({}));
  };

  /* ************************ Resubmit state start ************************  */
  useEffect(() => {
    if (resubmit_data?.status) {
      saveToStorage({
        key: StorageConstants?.USER_DETAIL,
        value: profile_data?.data?.data,
      });
      window.location.href = Config?.BASE_URL + "/profile";
    }
  }, [resubmit_data]);

  return (
    <>
      <div
        className="modal modelStyle fade"
        id="approval-box"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {/* <div className="modal modelStyle fade" id="approval-box" tabIndex={-1} aria-labelledby="exampleModalLabel" data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false"> */}
        <div className="modal-dialog  modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btnClose"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="icon-close"></span>
              </button>
              <div className="row">
                <div className="col-md-8 mx-auto text-center">
                  <div className="modelLogo">
                    <img src={ImageContainer?.Logo} />
                  </div>
                  {type == "profile" && (
                    <>
                      <h2>
                        <FormattedMessage id="approval_pending" />{" "}
                      </h2>
                      {/* <h2>Approval Pending from Admin</h2> */}
                      {/* <button type="button" className="btn btn-fill mb-4 mt-5" onClick={handleButtonData}>Done</button> */}
                    </>
                  )}

                  {/* {
                                        type == "profile-approved" && (
                                            <>
                                                <h2>Profile is approved by the admin</h2>
                                            </>
                                        )
                                    } */}
                  {type == "profile-rejected" && (
                    <>
                      {/* <h2>Approval Pending from Admin</h2> */}
                      <h2>
                        <FormattedMessage id="profile_rejected" />{" "}
                      </h2>
                      <h4>
                        {profile_data?.data?.data?.reject_reason
                          ? capitalizeFirstLetter(
                              profile_data?.data?.data?.reject_reason,
                            )
                          : ""}{" "}
                      </h4>
                      {/* <button type="button" className="btn btn-fill mb-4 mt-5" onClick={handleResubmit}>Resubmit</button> */}
                      {/* <Button/> */}
                      <Button
                        text="Resubmit"
                        type="button"
                        className="btn btn-fill mb-4 mt-5"
                        onClick={handleResubmit}
                        isLoading={resubmit_data?.loading}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ApprovalPendingModel);
